// redux\store.ts
import { configureStore } from "@reduxjs/toolkit";
import apiReducer from "./reducers/apiSlice";
import beneficiaryEditReducer from "./reducers/BeneficiarySlice";
import filterReducer from "./reducers/filterSlice";
import modalReducer from "./reducers/accountsModalSlice";
import tabReducer from "./reducers/tabSlice";
import manageUserSlice from "./reducers/manageUserSlice";
import countryReducer from "./reducers/countrySlice";
import settingsReducer from "./reducers/settingsSlice";
import authMatrixReducer from "./reducers/Authmatrixslice";
import envDataReducer from "./reducers/envDataSlice"; 
import userDataReducer from "./reducers/userData";
import userReducer from "./reducers/userSlice";
import dashboardLayoutReducer from "./reducers/dashboardLayoutSlice";
import notificationReducer from "./reducers/notificationsMessage";

export const store = configureStore({
  reducer: {
    api: apiReducer,
    beneficiaryEdit: beneficiaryEditReducer,
    filter: filterReducer,
    modal: modalReducer,
    tabs: tabReducer,
    manageUser: manageUserSlice,
    countries: countryReducer,
    settings: settingsReducer,
    authMatrix: authMatrixReducer,
    envData: envDataReducer,
    userData: userDataReducer,
    users: userReducer,
    dashboardLayout: dashboardLayoutReducer,
    notifications: notificationReducer,
  },
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
